// extracted by mini-css-extract-plugin
export default {"wrap":"skin2-module_wrap_7VxI7","player":"skin2-module_player_9hzB5","playList":"skin2-module_playList_Zv6Fy","playItem":"skin2-module_playItem_tTCsP"};